/* ============================================================
   S&T Pre-sale countdown (adapted from Reformd theme)
   Drives every [data-count-end-date] timer on the page.

   Markup contract (see global_hero-banner.liquid):
   - [data-count-end-date="YYYY-MM-DD HH:MM AM/PM"]  timer wrapper (Toronto time)
   - [data-selector]        the <ul id="..."> holding .days/.hours/.min/.sec numbers
   - [data-hide-countdown]  box hidden when its timer expires
   - [data-pre-count="true"] on state-1 timer box -> when it expires,
     the section's [data-main] content is removed and [data-pre-content]
     (sale-live state) is revealed.
   ============================================================ */
(function () {
  'use strict';
  if (window.stCountdownLoaded) return;
  window.stCountdownLoaded = true;

  var T = { second: 1000, minute: 60000, hour: 3600000, day: 86400000 };

  function addZero(v) {
    return v < 10 ? '0' + v : '' + v;
  }

  /* Parse "2026-09-30 09:00 AM" as Toronto (EDT, UTC-4) time */
  function getTorontoDate(dateString) {
    try {
      var parts = dateString.trim().split(/\s+/);
      var d = parts[0].split('-').map(Number);
      var t = parts[1].split(':').map(Number);
      var meridiem = (parts[2] || '').toUpperCase();
      var h = t[0];
      if (meridiem === 'PM' && h < 12) h += 12;
      if (meridiem === 'AM' && h === 12) h = 0;

      var iso = d[0] + '-' + addZero(d[1]) + '-' + addZero(d[2]) + 'T' + addZero(h) + ':' + addZero(t[1] || 0) + ':00-04:00';
      var date = new Date(iso);
      if (isNaN(date.getTime())) {
        date = new Date(d[0], d[1] - 1, d[2], h, t[1] || 0); /* fallback: visitor local time */
      }
      return date;
    } catch (e) {
      console.error('Countdown: could not parse date "' + dateString + '"', e);
      return null;
    }
  }

  /* When the state-1 (pre-sale) timer ends, swap to state 2 (sale live) */
  function swapToSale(hideWrap) {
    var sectionEl = hideWrap.closest('.shopify-section') || document;
    var main = hideWrap.closest('[data-main]');
    var pre = sectionEl.querySelector('[data-pre-content]');
    if (main) main.remove();
    if (pre) pre.classList.remove('hidden');
  }

  /* Paint one tick. Returns false when expired. */
  function render(obj, intervalId) {
    var list = document.querySelector(obj.s_id);
    if (!list) {
      if (intervalId) clearInterval(intervalId);
      return false;
    }
    var distance = obj.end - Date.now();
    var hideWrap = list.closest('[data-hide-countdown]');

    if (distance <= 0) {
      if (intervalId) clearInterval(intervalId);
      if (hideWrap) {
        hideWrap.classList.add('hidden');
        if (hideWrap.dataset.preCount === 'true') swapToSale(hideWrap);
      }
      return false;
    }

    try {
      var days = Math.floor(distance / T.day);
      var hours = Math.floor((distance % T.day) / T.hour);
      var minutes = Math.floor((distance % T.hour) / T.minute);
      var seconds = Math.floor((distance % T.minute) / T.second);

      var set = function (sel, val) {
        var el = list.querySelector(sel + ' .number');
        if (el) el.innerText = addZero(val);
      };
      set('.days', days);
      set('.hours', hours);
      set('.min', minutes);
      set('.sec', seconds);
      return true;
    } catch (e) {
      console.error('Countdown: render error', e);
      if (intervalId) clearInterval(intervalId);
      return false;
    }
  }

  function initTimer(element) {
    if (!element || element.dataset.stStarted === '1' || !element.dataset.countEndDate) return;
    element.dataset.stStarted = '1';

    var parsed = getTorontoDate(element.dataset.countEndDate);
    var selector = element.querySelector('[data-selector]');
    if (!parsed || isNaN(parsed.getTime()) || !selector || !selector.id) return;

    var obj = { end: parsed.getTime(), s_id: '#' + selector.id };

    if (render(obj, null)) {
      var iv = setInterval(function () {
        render(obj, iv);
      }, T.second);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-count-end-date]').forEach(initTimer);
    /* reveal content that was server-hidden to avoid a wrong-state flash */
    document.querySelectorAll('.banner-content.opacity-0').forEach(function (el) {
      el.classList.remove('opacity-0');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor: re-init when a section reloads */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();